module.exports = __webpack_public_path__ + "static/media/hub_transporters.1574feff.xlsx";